import React from 'react'
import cx from 'classnames'
import Image from '../Image/Image'
import spinner from './spinner.svg'
import spinnerDark from './spinner-dark.svg'
import styles from './Loader.module.scss'

type TProps = {
  className?: string
  theme?: 'light' | 'dark'
}

const Loader = ({ className, theme = 'light' }: TProps) => {
  return (
    <div className={cx([styles.root, className])}>
      <Image src={theme === 'dark' ? spinnerDark : spinner} alt="Loading..." />
    </div>
  )
}

export default Loader
